const o = "{{currentTime}} de {{duration}}", t = "Resultado da pesquisa {{current}} de {{total}}", n = "Nenhum resultado encontrado", e = "{{count}} resultado encontrado", a = "{{count}} resultados encontrados", s = 'Jogando de $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', c = 'Jogando de $t(MINUTES, { "count": {{minutes}} }) e $t(SECONDS, { "count": {{seconds}} }).', r = 'Jogando de $t(SECONDS, { "count": {{seconds}} }).', A = "Erro ao salvar as alterações na transcrição.", E = "Transcrição linha no {{time}}. O conteúdo é: {{text}}.", T = 'Contêiner de linhas da transcrição. Há $t(TRANSCRIPT_LINES, { "count": {{count}} }) dentro este contêiner. Para navegar dentro deste recipiente, use a tecla de seta para baixo.', _ = "Salvando alterações...", S = "Mudanças salvas para transcrição.", d = "O botão para atualizar legendas já está disponível.", i = "Ação", R = "Adicionar anotação em {{time}}", N = "Adicionar pergunta em {{time}}", I = "Anotações", u = "Automático", O = "Auto ({{quality}})", C = "Voltar", P = "Legenda", l = "Idioma da legenda", U = "Gerenciar legendas", L = "Excluir {{language}}", m = "Tamanho da fonte", D = "Idioma da legenda: {{language}}", p = "{{language}} (automático)", M = "Limpar pesquisa", g = "Fechar", G = "Comentários", Y = "Continuar", v = "Diminuir a velocidade de reprodução", h = "Diminuir o volume em {{percent}}%", V = "Seta para baixo", H = "Fechar editor de transcrição", B = "Atualizar legendas", F = "Erro!", K = "Salvando...", f = "Salvas!", x = "Editar transcrição", q = "Texto não pode ser vazio!", J = "Tela cheia", Q = "{{count}} hora", W = "{{count}} horas", $ = "Aumentar a velocidade de reprodução", b = "Aumentar o volume em {{percent}}%", z = "Inverter cores", Z = "Ir para uma porcentagem específica (1-10%, 2-20%, etc.)", y = "Ir para o início", X = "Ações para {{title}}", j = "Atalhos de Teclado", k = "Idioma", w = "Seta para a esquerda", oo = "Menu principal", to = "{{count}} minuto", no = "{{count}} minutos", eo = "Silenciar", ao = "Silenciada", so = "Próximo idioma da legenda", co = "Próximo resultado da pesquisa", ro = "Desligar", Ao = "Na parte superior", Eo = "Abrir anotação em {{time}}", To = "Abrir teste concluído em {{time}}", _o = "Abrir teste em {{time}}", So = "Pausar", io = "Reproduzir", Ro = "Velocidade de reprodução", No = "Velocidade de reprodução: {{speed}}x", Io = "Idioma da legenda anterior", uo = "Resultado da pesquisa anterior", Oo = "Qualidade", Co = "Menu de qualidade", Po = "Replay", lo = "Redefinir a velocidade de reprodução", Uo = "Seta direita", Lo = "Pesquisa na transcrição", mo = "{{count}} segundo", Do = "{{count}} segundos", po = "Procurar para trás: {{seconds}} segundos", Mo = "Procurar para frente: {{seconds}} segundos", go = "Configurações", Go = "Atalho", Yo = "Mídia detalhes e ferramentas", vo = "Espaço", ho = "Menu de velocidade de reprodução", Vo = "Iniciar rolagem automática", Ho = "Ativar legendas", Bo = "Alternar silenciado", Fo = "Alternar entre reprodução/pausa", Ko = "é {{count}} linha de transcrição", fo = "são {{count}} linhas de transcrição", xo = "Carregando transcrição...", qo = "Não foi possível carregar a transcrição.", Jo = "Opções de transcrição", Qo = "Tentar novamente", Wo = "Transcrição indisponível", $o = "Seta para cima", bo = "Configurações de vídeo", zo = "Volume", Zo = "Volume: {{volume}}%", yo = {
  A11Y_DURATION: o,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: n,
  A11Y_SEARCH_RESULTS_FOUND: e,
  A11Y_SEARCH_RESULTS_FOUND_other: a,
  A11Y_TIMESTAMP_JUMP_HOURS: s,
  A11Y_TIMESTAMP_JUMP_MINUTES: c,
  A11Y_TIMESTAMP_JUMP_SECONDS: r,
  A11Y_TRANSCRIPT_ERROR: A,
  A11Y_TRANSCRIPT_LINE: E,
  A11Y_TRANSCRIPT_LINES: T,
  A11Y_TRANSCRIPT_SAVING: _,
  A11Y_TRANSCRIPT_SUCCESS: S,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: d,
  ACTION: i,
  ADD_ANNOTATION_AT: R,
  ADD_QUESTION_AT: N,
  ANNOTATIONS: I,
  AUTO: u,
  AUTO_QUALITY: O,
  BACK: C,
  CAPTIONS: P,
  CAPTIONS_LANGUAGE: l,
  CAPTIONS_MANAGE: U,
  CAPTION_DELETE: L,
  CAPTION_FONT_SIZE: m,
  CAPTION_LANGUAGE: D,
  CAPTION_LANGUAGE_AUTOMATIC: p,
  CLEAR_SEARCH: M,
  CLOSE: g,
  COMMENTS: G,
  CONTINUE: Y,
  DECREASE_PLAYBACK_SPEED: v,
  DECREASE_VOLUME: h,
  DOWN_ARROW: V,
  EDIT_CLOSE: H,
  EDIT_CONFIRM: B,
  EDIT_ERROR: F,
  EDIT_SAVING: K,
  EDIT_SUCCESS: f,
  EDIT_TRANSCRIPT: x,
  EDIT_VALIDATION_ERROR: q,
  FULLSCREEN: J,
  HOURS: Q,
  HOURS_other: W,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: b,
  INVERT_COLORS: z,
  JUMP_TO_PERCENTAGE: Z,
  JUMP_TO_START: y,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: j,
  LANGUAGE: k,
  LEFT_ARROW: w,
  MAIN_MENU: oo,
  MINUTES: to,
  MINUTES_other: no,
  MUTE: eo,
  MUTED: ao,
  NEXT_CAPTION_LANGUAGE: so,
  NEXT_HIT: co,
  OFF: ro,
  ON_TOP: Ao,
  OPEN_ANNOTATION_AT: Eo,
  OPEN_COMPLETED_QUIZ_AT: To,
  OPEN_QUIZ_AT: _o,
  PAUSE: So,
  PLAY: io,
  PLAYBACK_SPEED: Ro,
  PLAYBACK_SPEED_MESSAGE: No,
  PREVIOUS_CAPTION_LANGUAGE: Io,
  PREVIOUS_HIT: uo,
  QUALITY: Oo,
  QUALITY_MENU: Co,
  REPLAY: Po,
  RESET_PLAYBACK_SPEED: lo,
  RIGHT_ARROW: Uo,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Lo,
  SECONDS: mo,
  SECONDS_other: Do,
  SEEK_BACKWARD: po,
  SEEK_FORWARD: Mo,
  SETTINGS: go,
  SHORTCUT: Go,
  SIDEBAR: Yo,
  SPACE: vo,
  SPEED_MENU: ho,
  START_AUTOSCROLL: Vo,
  TOGGLE_CAPTIONS: Ho,
  TOGGLE_MUTED: Bo,
  TOGGLE_PLAY_PAUSE: Fo,
  TRANSCRIPT_LINES: Ko,
  TRANSCRIPT_LINES_other: fo,
  TRANSCRIPT_LOADING: xo,
  TRANSCRIPT_LOAD_ERROR: qo,
  TRANSCRIPT_OPTIONS: Jo,
  TRANSCRIPT_RETRY: Qo,
  TRANSCRIPT_UNAVAILABLE: Wo,
  UP_ARROW: $o,
  VIDEO_SETTINGS: bo,
  VOLUME: zo,
  VOLUME_VALUE: Zo
};
export {
  o as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  n as A11Y_SEARCH_NO_RESULTS,
  e as A11Y_SEARCH_RESULTS_FOUND,
  a as A11Y_SEARCH_RESULTS_FOUND_other,
  s as A11Y_TIMESTAMP_JUMP_HOURS,
  c as A11Y_TIMESTAMP_JUMP_MINUTES,
  r as A11Y_TIMESTAMP_JUMP_SECONDS,
  A as A11Y_TRANSCRIPT_ERROR,
  E as A11Y_TRANSCRIPT_LINE,
  T as A11Y_TRANSCRIPT_LINES,
  _ as A11Y_TRANSCRIPT_SAVING,
  S as A11Y_TRANSCRIPT_SUCCESS,
  d as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  i as ACTION,
  R as ADD_ANNOTATION_AT,
  N as ADD_QUESTION_AT,
  I as ANNOTATIONS,
  u as AUTO,
  O as AUTO_QUALITY,
  C as BACK,
  P as CAPTIONS,
  l as CAPTIONS_LANGUAGE,
  U as CAPTIONS_MANAGE,
  L as CAPTION_DELETE,
  m as CAPTION_FONT_SIZE,
  D as CAPTION_LANGUAGE,
  p as CAPTION_LANGUAGE_AUTOMATIC,
  M as CLEAR_SEARCH,
  g as CLOSE,
  G as COMMENTS,
  Y as CONTINUE,
  v as DECREASE_PLAYBACK_SPEED,
  h as DECREASE_VOLUME,
  V as DOWN_ARROW,
  H as EDIT_CLOSE,
  B as EDIT_CONFIRM,
  F as EDIT_ERROR,
  K as EDIT_SAVING,
  f as EDIT_SUCCESS,
  x as EDIT_TRANSCRIPT,
  q as EDIT_VALIDATION_ERROR,
  J as FULLSCREEN,
  Q as HOURS,
  W as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  b as INCREASE_VOLUME,
  z as INVERT_COLORS,
  Z as JUMP_TO_PERCENTAGE,
  y as JUMP_TO_START,
  X as KEBAB_MENU,
  j as KEYBOARD_SHORTCUTS,
  k as LANGUAGE,
  w as LEFT_ARROW,
  oo as MAIN_MENU,
  to as MINUTES,
  no as MINUTES_other,
  eo as MUTE,
  ao as MUTED,
  so as NEXT_CAPTION_LANGUAGE,
  co as NEXT_HIT,
  ro as OFF,
  Ao as ON_TOP,
  Eo as OPEN_ANNOTATION_AT,
  To as OPEN_COMPLETED_QUIZ_AT,
  _o as OPEN_QUIZ_AT,
  So as PAUSE,
  io as PLAY,
  Ro as PLAYBACK_SPEED,
  No as PLAYBACK_SPEED_MESSAGE,
  Io as PREVIOUS_CAPTION_LANGUAGE,
  uo as PREVIOUS_HIT,
  Oo as QUALITY,
  Co as QUALITY_MENU,
  Po as REPLAY,
  lo as RESET_PLAYBACK_SPEED,
  Uo as RIGHT_ARROW,
  Lo as SEARCH_TRANSCRIPT_PLACEHOLDER,
  mo as SECONDS,
  Do as SECONDS_other,
  po as SEEK_BACKWARD,
  Mo as SEEK_FORWARD,
  go as SETTINGS,
  Go as SHORTCUT,
  Yo as SIDEBAR,
  vo as SPACE,
  ho as SPEED_MENU,
  Vo as START_AUTOSCROLL,
  Ho as TOGGLE_CAPTIONS,
  Bo as TOGGLE_MUTED,
  Fo as TOGGLE_PLAY_PAUSE,
  Ko as TRANSCRIPT_LINES,
  fo as TRANSCRIPT_LINES_other,
  xo as TRANSCRIPT_LOADING,
  qo as TRANSCRIPT_LOAD_ERROR,
  Jo as TRANSCRIPT_OPTIONS,
  Qo as TRANSCRIPT_RETRY,
  Wo as TRANSCRIPT_UNAVAILABLE,
  $o as UP_ARROW,
  bo as VIDEO_SETTINGS,
  zo as VOLUME,
  Zo as VOLUME_VALUE,
  yo as default
};
